import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
export const DeleteMilestoneModal = ({
  title,
  onClose,
  onDelete
}) => {
  return /*#__PURE__*/_jsx(ConfirmModal, {
    width: 512,
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dealPlan.milestones.deleteConfirmTitle"
    }),
    description: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "dealPlan.milestones.deleteConfirmDescription",
      options: {
        milestoneName: title
      }
    }),
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dealPlan.milestones.deleteConfirmDelete"
    }),
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dealPlan.milestones.deleteConfirmCancel"
    }),
    onConfirm: onDelete,
    onReject: onClose,
    confirmUse: "danger",
    rejectUse: "primary-white",
    rejectButtonProps: {
      borderColor: 'border-core-default',
      style: {
        marginLeft: 'auto'
      }
    }
  });
};